angular
.module('inkfinder')
.factory('GroupParticipants', function GroupParticipants(
  Session,
  Messages,
  Conversations,
  _,
  $log,
  moment
) {
  // Public methods
  GroupParticipants.group = group;

  /**
   * @name filter
   * @description Filter the participants by comparing the date of the last
   * message to the last read date.
   * @param {array} participants The array of participants to filter
   * @return {array} Returns an array of filtered messages
   */
  function group(participants) {
    let newParticipants = [];

    // Filter out all participants with no last message object
    let participantsWithLastMessages =
    _.filter(participants, function(participant) {
      return participant.last_message !== null;
    });

    // Ordering to get the latest message
    newParticipants =
    _.orderBy(participantsWithLastMessages, [(participant) => {
      if (participant.last_message) {
        return participant.last_message.created;
      }
    }], ['desc']);
    return newParticipants;
  }
  return GroupParticipants;
});



// WEBPACK FOOTER //
// ./components/messages/participants/util/group-participants.service.js